

const Social = ({link, icon, tooltip}) => {

      return (
            <a className="jd_social__menu_link tooltip" href={link} target="_blank" rel="noreferrer" data-tooltip={tooltip}>{icon}</a>
      )
}

export default Social